import { render, staticRenderFns } from "./ModalBankAccountDelete.vue?vue&type=template&id=21500baf"
import script from "./ModalBankAccountDelete.vue?vue&type=script&lang=js"
export * from "./ModalBankAccountDelete.vue?vue&type=script&lang=js"
import style0 from "./ModalBankAccountDelete.vue?vue&type=style&index=0&id=21500baf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports